import * as React from 'react';

import { Container, Form, Input, Modal, ModalBody } from 'reactstrap';

import * as SettingsApi from '../../api/settings';
import * as UtilApi from '../../api/util';

import Localization from '../../config/localization';

import BackButton from '../../components/BackButton';
import Loader from '../../components/Loader';

import CloseSvg from '../../components/Svg/close';
import WarningSvg from '../../components/Svg/warning';

import { MonthToLocal } from '../../lib/months';
import Notifications from '../../lib/notifications';
import { Add0, ToNumber, ToString } from '../../lib/utils';

import './AdminBlockMonth.scss';

class AdminBlockMonth extends React.Component<AdminBlockMonth.IProps, AdminBlockMonth.IState> {
  state: AdminBlockMonth.IState = {
    loading: false,
    loadingMessage: '',

    blockedMonths: [],
    monthToChange: undefined,

    MONTHS: undefined
  };

  async componentDidMount() {
    try {
      await this.setState({ loading: true, loadingMessage: '' });

      const results = await Promise.all([this._getClosedMonth(), UtilApi.GetMonthsBlock()]);

      return this.setState({ MONTHS: results[1].data || [], loading: false, loadingMessage: '' });
    } catch (error) {
      Notifications.error(error && error.message);

      return this.setState({ loading: false });
    }
  }

  rebderMonths = () => {
    if (!this.state.MONTHS) {
      return null;
    }

    return this.state.MONTHS.map(month => {
      if (!month) {
        return null;
      }

      return (
        <div key={month} className="d-flex mt-4">
          <p className="eon-title eon-middle-grey my-auto w-10">{Localization.Months[MonthToLocal(month)]}</p>
          <label className={`eon-switch eon-red my-auto ${this._isMonthOpen(MonthToLocal(month)) ? 'checked' : 'eon-middle-grey'}`}>
            <Input
              id={ToString(MonthToLocal(month))}
              type="checkbox"
              checked={this._isMonthOpen(MonthToLocal(month))}
              onChange={this._activeMonthShowModal}
            />
          </label>
          <p className="eon-title eon-middle-grey my-auto ml-4">
            {!this._isMonthOpen(MonthToLocal(month)) ? Localization.adminBlockMonthOpenMonth : Localization.adminBlockMonthClosedMonth}
          </p>
        </div>
      );
    });
  };

  render() {
    return (
      <Container className="block-month px-5 py-4 my-4">
        <BackButton />
        <Loader loading={this.state.loading} loadingMessage={this.state.loadingMessage} />

        <h4 className="mt-5 eon-title eon-red">{Localization.adminBlockMonthTitle}</h4>
        <p className="mt-3 eon-title eon-middle-grey wrap-pre-line">{Localization.adminBlockMonthInfo}</p>

        <Form>{this.rebderMonths()}</Form>

        <Modal isOpen={!!this.state.monthToChange} toggle={this._closeChangeMonthStatusModal} centered>
          <ModalBody className="modal-body-block-month">
            <div className="d-flex">
              <WarningSvg />
              <h4 className="eon-title my-auto h-100">
                {Localization.formatString(
                  !this._isMonthOpen(this.state.monthToChange)
                    ? Localization.adminBlockMonthBlockModalTitle
                    : Localization.adminBlockMonthUnblockModalTitle,
                  Localization.Months[Add0(this.state.monthToChange)]
                )}
              </h4>
            </div>
            <p className="eon-title eon-middle-grey mx-5 px-1">
              {Localization.formatString(
                !this._isMonthOpen(this.state.monthToChange)
                  ? Localization.adminBlockMonthBlockModalInfo
                  : Localization.adminBlockMonthUnblockModalInfo,
                Localization.Months[Add0(this.state.monthToChange)]
              )}
            </p>
            <div className="mt-5 mb-4 ml-3">
              <button className="eon-button bg-eon-red eon-white mr-5" onClick={this._saveChangeMonthStatus}>
                <span className="px-3">
                  {!this._isMonthOpen(this.state.monthToChange)
                    ? Localization.adminBlockMonthBlockButton
                    : Localization.adminBlockMonthUnblockButton}
                </span>
              </button>
              <button className="eon-button bg-eon-white eon-middle-grey ml-4 c-pointer" onClick={this._closeChangeMonthStatusModal}>
                <CloseSvg />
                <span className="eon-middle-grey">{Localization.adminBlockMonthCloseButton}</span>
              </button>
            </div>
          </ModalBody>
        </Modal>
      </Container>
    );
  }

  _closeChangeMonthStatusModal = () => this.setState({ monthToChange: 0 });

  _isMonthOpen = (month?: string | number) =>
    this.state.blockedMonths && !!this.state.blockedMonths.length && !!this.state.blockedMonths[ToNumber(month) - 1];

  _getClosedMonth = async () => {
    try {
      await this.setState({ loading: true });

      const response = await SettingsApi.GetBlockedMonths();

      return this.setState({ blockedMonths: response.data, loading: false });
    } catch (error) {
      Notifications.error(error && error.message);

      return this.setState({ loading: false });
    }
  };

  _saveChangeMonthStatus = async () => {
    try {
      await this.setState({ loading: true, loadingMessage: '' });

      await SettingsApi.ChangeMonth({
        month: this.state.monthToChange || '',
        status: !this._isMonthOpen(this.state.monthToChange) ? 1 : 0
      });

      await this._getClosedMonth();

      this._closeChangeMonthStatusModal();

      return this.setState({ loading: false, loadingMessage: '' });
    } catch (error) {
      Notifications.error(error && error.message);

      return this.setState({ loading: false });
    }
  };

  _activeMonthShowModal = (event: React.ChangeEvent<HTMLInputElement>) => {
    event.preventDefault();

    const element = event.currentTarget || event.target || {};

    return this.setState({ monthToChange: parseInt(element.id, 10) });
  };
}

export default AdminBlockMonth;
